import React from "react";
import { ShopContext } from "../../Context";
import menu from "../../assets/menu.svg";
import image_main_1 from '../../assets/image_main_1.png';
import { Menu } from "../Menu";
import cart from "../../assets/cart.svg";
import { Link } from "react-router-dom";


export const Header=()=>{
    const{
        showMenu,
        setShowmenu,
        cartProducts
        // services,
    }=React.useContext(ShopContext);

    return (

        <header className="App-header">
            <div className='App-header-menu'>
                <img src={menu} alt='icono menu' onClick={()=> setShowmenu(!showMenu)}/>
            </div>
            <div className="App-header-image">
                <img src={image_main_1} alt="header-imagen"/>
            </div>
            <div className='App-header-title'>                
                Lorem, ipsum dolor 
            </div>
           
            <Menu ></Menu>    
            <div className="container-cart-products">
            <Link to={'../Pedido'}>
                    <img src={cart} alt="imagen carrito de compras"></img>                        
            </Link>
            <span className="App-header-count-cart-products">{cartProducts.length}</span>
            </div>
        </header>    

    )
}